import {
   Button,
   Container,
   Grid,
   IconButton,
   TextField,
   Tooltip,
   Typography
} from '@mui/material';
import React, {useState, useEffect} from 'react';
import {makeStyles} from 'tss-react/mui';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {
   column,
   filtrosIniciales,
   meses,
   options
} from '../constants/constantes';
import {ConfirmDialog, SelectBase, toast} from 'lib.front';
import MUIDataTable from 'mui-datatables';
import {connect, useDispatch} from 'react-redux';
import useTipoCambio from '../hooks/useTipoCambio';
import useListaTiposCambio from '../hooks/useListaTipoCambio';
import TipoCambioDialog from '../components/tipoCambioDialog';
import {parse} from 'date-fns';
import useEditTipoCambio from '../hooks/useEditTipoCambio';
import useAddTipoCambio from '../hooks/useAddTipoCambio';
import {loadingModal} from 'src/redux-app';

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   input: {
      maxWidth: '500px',
   }
}));

const TipoCambio = () => {
   const {classes, cx} = useStyles();
   const dispatch = useDispatch();
   const [filtros, setFiltros] = useState(filtrosIniciales);
   const [dataTable, setDataTable] = useState([]);
   const [openDialog, setOpenDialog] = useState(false);
   const [dialogMode, setDialogMode] = useState('create');
   const [isLoading, setIsLoading] = useState(false);
   const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

   const [tipoCambioForm, setTipoCambioForm] = useState({
      fecha: new Date(),
      codMoneda: 'USD',
      compraFiscal: 0,
      ventaFiscal: 0
   });

   const [tipoCambioFormErrors, setTipoCambioFormError] = useState({
      fecha: '',
      codMoneda: '',
      compraFiscal: '',
      ventaFiscal: ''
   });

   const {postAddTipoCambio} = useAddTipoCambio();

   const fetchAddTipoCambio = async () => {
      const result = await postAddTipoCambio({
         fecha: tipoCambioForm.fecha,
         moneda: tipoCambioForm.codMoneda,
         compraFiscal: tipoCambioForm.compraFiscal,
         ventaFiscal: tipoCambioForm.ventaFiscal
      });
      if (result) {
         toast.showSucces(result.message);
         fetchListaTipoCambio();
      }
      initForm();
      setOpenDialog(false);
   };

   const {postEditTipoCambio} = useEditTipoCambio();
   const fetchEditarTipoCambio = async () => {
      const result = await postEditTipoCambio({
         fecha: tipoCambioForm.fecha,
         moneda: tipoCambioForm.codMoneda,
         compraFiscal: tipoCambioForm.compraFiscal,
         ventaFiscal: tipoCambioForm.ventaFiscal
      });
      if (result) {
         toast.showSucces(result.message);
         fetchListaTipoCambio();
      }
      initForm();
   };

   const {getTipoCambioSUNAT} = useTipoCambio();

   const fetchTipoCambio = async () => {
      const result = await getTipoCambioSUNAT({
         fecha: tipoCambioForm.fecha,
         moneda: tipoCambioForm.codMoneda
      });

      if (typeof result === 'string') {
         if (result.includes('Tipo de cambio no existe')) {
            await fetchAddTipoCambio();
         } else toast.showError(result);
      } else {
         setOpenConfirmDialog(true);
      }
   };

   const {getListaTipoCambioSUNAT} = useListaTiposCambio();
   const fetchListaTipoCambio = async () => {
      setIsLoading(true);
      const result = await getListaTipoCambioSUNAT({
         anio: filtros.anio,
         mes: filtros.mes,
         moneda: filtros.moneda
      });
      setDataTable(result);
      setIsLoading(false);
   };

   const handleChangeFiltros = (campo, valor) => {
      setFiltros(() => {
         return {...filtros, [campo]: valor};
      });
   };

   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }

   function buscarTipoCambio() {
      fetchListaTipoCambio();
   }
   function agregarTipoCambio() {
      setDialogMode('create');
      setOpenDialog(true);
   }

   function handleEditarTipoCambio(rowData) {
      let data = {
         fecha: parse(rowData[1], "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date()),
         codMoneda: rowData[0],
         compraFiscal: rowData[2],
         ventaFiscal: rowData[3]
      };
      setTipoCambioForm(data);
      setTipoCambioFormError({
         fecha: '',
         codMoneda: '',
         compraFiscal: '',
         ventaFiscal: ''
      });
      setDialogMode('edit');
      setOpenDialog(true);
   }
   // Handlers para los campos
   const handleFormChange = (name, value) => {
      setTipoCambioForm(prev => ({...prev, [name]: value}));
   };
   const handleClose = () => {
      setOpenDialog(false);
      initForm();
   };

   const initForm = () => {
      setTipoCambioForm({
         fecha: new Date(),
         codMoneda: 'USD',
         compraFiscal: 0,
         ventaFiscal: 0
      });
      setTipoCambioFormError({
         fecha: '',
         codMoneda: '',
         compraFiscal: '',
         ventaFiscal: ''
      });
   };

   async function handleEdit() {
      setIsLoading(true);
      fetchEditarTipoCambio();
      setOpenDialog(false);
   }

   async function handleCreate() {
      setIsLoading(true);
      fetchTipoCambio();
   }

   const columnasAdicionales = [
      {
         name: '',
         label: '',
         options: {
            sort: false,
            display: true,
            customBodyRender: (value, tableMeta, updateValue) => {
               return (
                  <Tooltip title="Editar">
                     <IconButton
                        onClick={() => handleEditarTipoCambio(tableMeta.rowData)}
                        size="large"
                     >
                        <EditOutlinedIcon />
                     </IconButton>
                  </Tooltip>
               );
            }
         }
      }
   ];

   function closeConfirmar() {
      setOpenConfirmDialog(false);
      setIsLoading(false);
   }

   async function confirmarOperacion() {
      fetchEditarTipoCambio();
      setOpenDialog(false);
   }

   useEffect(() => {
      openWaitModal(isLoading);
   }, [isLoading]);

   return (
      <Container className={cx('containerbox', classes.container)} maxWidth="md">
         <Grid container spacing={1}>
            <Grid container item xs={12}>
               <Grid item xs={9}>
                  <Typography variant="h4" gutterBottom align="center">
                     Gestionar Tipo de Cambio
                  </Typography>
               </Grid>
               <Grid item xs={3}>
                  <Button variant="contained" fullWidth onClick={agregarTipoCambio}>
                     Agregar
                  </Button>
               </Grid>
            </Grid>
            <Grid container item spacing={1}>
               <Grid container item spacing={1} xs={12} sx={{justifyContent: 'space-between'}}>
                  <Grid container item xs={9} spacing={1}>
                     <Grid item xs={5}>
                        <TextField
                           label="Año"
                           variant="outlined"
                           margin="dense"
                           fullWidth
                           required
                           value={filtros.anio}
                           type="number"
                           onChange={elegido => handleChangeFiltros('anio', elegido.target.value)}
                           inputProps={{
                              min: 2021
                           }}
                           className={classes.input}
                        />
                     </Grid>

                     <Grid item xs={5}>
                        <SelectBase
                           label="Mes"
                           value={meses.find(option => option.value === filtros.mes)}
                           onChange={selectedOption =>
                              handleChangeFiltros('mes', selectedOption.value)
                           }
                           options={meses}
                           getOptionLabel={e => e.label}
                           getOptionValue={e => e.value}
                           placeholder="Selecciona un mes"
                           variant="outlined"
                           margin="dense"
                           fullWidth
                           required
                           className={classes.input}
                        />
                     </Grid>
                  </Grid>
                  <Grid item xs={3} sx={{marginTop: '8px'}}>
                     <Button variant="contained" fullWidth onClick={buscarTipoCambio}>
                        Buscar
                     </Button>
                  </Grid>
               </Grid>
               <Grid item xs={12}>
                     <MUIDataTable
                        options={options}
                        columns={[...column, ...columnasAdicionales]}
                        data={dataTable}
                     />
               </Grid>
            </Grid>
         </Grid>
         <TipoCambioDialog
            open={openDialog}
            onClose={handleClose}
            onSubmit={dialogMode === 'edit' ? handleEdit : handleCreate}
            tipoCambioForm={tipoCambioForm}
            tipoCambioFormErrors={tipoCambioFormErrors}
            handleFormChange={handleFormChange}
            modo={dialogMode}
         />
         <ConfirmDialog
            variant="warning"
            open={openConfirmDialog}
            setOpen={closeConfirmar}
            onConfirm={confirmarOperacion}
         >
            Ya existe un tipo de cambio para la fecha{' '}
            {`${tipoCambioForm.fecha.getFullYear()}-${tipoCambioForm.fecha.getMonth() +
               1}-${tipoCambioForm.fecha.getDate()}`}{' '}
            y moneda {tipoCambioForm.codMoneda}. ¿Desea editar el registro existente?
         </ConfirmDialog>
      </Container>
   );
};

export default TipoCambio;
